const NotEnabled = () => {
  return (
    <main className="py-18 grid min-h-full  place-items-center px-6 sm:py-24 lg:px-8 mx-auto">
      <div className="text-center">
        <p className="text-base font-semibold text-primary-600 dark:text-primary-400">
          403
        </p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-mono-900 dark:text-mono-200 sm:text-5xl">
          Team schedule not enabled
        </h1>
        <p className="mt-6 text-base leading-7 ">
          Please select 'Enable' under 'Share Schedule' in your team board
          settings
        </p>
      </div>
    </main>
  );
};

export default NotEnabled;
